<header class="ao-page-head">
  <div>
    <div class="ao-eyebrow">Inter-store inventory</div>
    <h2>Borrowing</h2>
  </div>
  <div class="ao-borrow-legend">
    <span><i class="ao-dot"></i>On loan</span>
    <span><i class="ao-dot ao-dot-due"></i>Reimbursement due</span>
    <span><i class="ao-dot ao-dot-done"></i>Settled / sent back</span>
  </div>
</header>

<mat-card appearance="outlined" *ngIf="borrowingStore">
  <mat-toolbar class="ao-section-bar">
    <span>{{ otherStoreName }} TO {{ currentStore.storeName }}</span>
  </mat-toolbar>
  <mat-card-content>
    <app-borrowing-vendors [borrowingStore]="0"></app-borrowing-vendors>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" *ngIf="borrowingStore">
  <mat-toolbar class="ao-section-bar">
    <span>{{ currentStore.storeName }} TO {{ borrowingStore.storeName }}</span>

    <mat-select #formRow #statusSelect placeholder="BORROWING" [(value)]="borrowingStore._id">
      <ng-container *ngFor="let storeOption of storeOptions">
        <mat-option *ngIf="storeOption._id !== currentStore._id" [value]="storeOption._id">
            {{storeOption.storeName}}
        </mat-option>
      </ng-container>
    </mat-select>

  </mat-toolbar>
  <mat-card-content>
    <app-borrowing-vendors [borrowingStore]="borrowingStore._id" ></app-borrowing-vendors>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" *ngIf="currentRentalUser">
  <mat-toolbar class="ao-section-bar">
    <span>RENTING {{ currentStore.storeName }} TO {{ currentRentalUser.name }}</span>

    <mat-select placeholder="RENTING" [value]="currentRentalUser._id" (selectionChange)="changeRentalUser($event)">
      <mat-option *ngFor="let rentalUser of rentalUsers" [value]="rentalUser._id">
        {{rentalUser.name}}
      </mat-option>
    </mat-select>

  </mat-toolbar>
  <mat-card-content>
    <app-borrowing-vendors [rentingUser]="currentRentalUser._id"></app-borrowing-vendors>
  </mat-card-content>
</mat-card>
